<div>
  <section class="patient-details-wrapper">
    <gen-dynamic-form
      class="patientSearch"
      [formConfig]="inputConfig"
      [editMode]="false"
      [formData] = "formData"
      [disabled]="widgetConfigPayload?.disabled"
      [popupMode]="widgetConfigPayload?.popupMode"
      (formChange)="updateSearchObject($event.form)"
      [resetForm]="restForm"
      [stayInFormMode]="true"
      [listenToDataChange]="listenToDataChange"
      [submitted]="widgetFormInstanceSubmitted"
    ></gen-dynamic-form>
    <gen-button
            class="addPatientBtn"
      *ngIf="widgetConfigPayload?.addButton"
      [text]="widgetConfigPayload?.addButton?.text"
      [type]="widgetConfigPayload?.addButton?.type"
      [iconClass]="widgetConfigPayload?.addButton?.iconClass"
      [disabled]="widgetConfigPayload?.disabled"
      (click)="addNewPatient()"
    ></gen-button>
    <gen-user-counter-warning [name]="patientName" [userId]="patientId" [showDuplicatePatient]="showDuplicatePatientWarning"
                              [backUrl]="backUrl" [backUrlParams]="backUrlParams"
    ></gen-user-counter-warning>
  </section>
</div>
